import React, { useState } from "react";
import Button from "../../../../UI/Button/Button";
import Input from "../../../../UI/Input/Input";
import { connect } from "react-redux";
import classes from "./EnableMemberModal.css";
import * as actions from "../../../../store/actions";
import { USER_ENABLED_BY_ADMIN } from "../../../../shared/Constants";
import { checkValidity } from "../../../../shared/utility";
import Spinner from "../../../../UI/Spinner/Spinner";
import Message from "../../../../components/Message/Message";
import CloseStatic from '../../../../assets/images/CloseStatic.png'

const EnableMemberModal = (props) => {
  const [valid, setValid] = useState(false);
  const [formState, setFormState] = useState({
    incidentTicket: {
      elementType: "inputKeyPress",
      elementConfig: {
        type: "text",
        id: "incidentTicket",
        placeholder: "Incident Ticket",
        minLength: 2,
        maxLength: 255,
        pattern: "[a-zA-Z0-9]{1,30}",
        title: "Invalid alpha-numeric characters",
      },
      value: "",
      validation: {
        required: true,
        minlength: 2,
        maxlength: 255,
      },
      disabled: false,
      valid: true,
      touched: false,
      label: "Incident Ticket",
      inputType: "QuickSearch",
    },
  });

  const clearSearch = (event) => {
    event.preventDefault();
    props.closeModal();
  }

  const enableDisableForm = (
    <div className={classes.formLayout}>
      {Object.keys(formState).map((key) => (
        <Input
          key={key}
          className={"SecurityInput"}
          elementType={formState[key].elementType}
          elementConfig={formState[key].elementConfig}
          value={formState[key].value}
          invalid={!formState[key].valid}
          shouldValidate={formState[key].validation}
          touched={formState[key].touched}
          disabled={formState[key].disabled}
          label={formState[key].label}
          changed={(event) => inputChangedHandler(event, key)}
          inputType={formState[key].inputType}
        />
      ))}
    </div>
  );

  const enableMember = (e) => {
    e.preventDefault();
    const userData = {
      hsid: props.uuid,
      incidentTicket: formState.incidentTicket.value,
      info: USER_ENABLED_BY_ADMIN,
      userid: props.username,
    };
    props.enableMember(userData, "disabled");
  };

  const inputChangedHandler = (event, inputIdentifier) => {
    let updatedForm = { ...formState };

    const updatedFormElement = { ...updatedForm[inputIdentifier] };
    let targetValue = event.target.value;
    updatedFormElement.value = targetValue;
    let formIsValid = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    if (targetValue) {
      const validation = checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
      updatedFormElement.valid = validation.isValid;
    } else {
      updatedFormElement.valid = false;
    }
    setValid(updatedFormElement.valid);
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }
    setFormState(updatedForm);
  };

  return (
    <div style={{padding:'20px'}}>
      <img src={CloseStatic} alt={"X"} onClick={clearSearch} style={{position:'absolute', top:'5px', right:'5px', height:'40px', width:'40px'}}/>
      <h2 className={classes.FormTitle}>Enable Member</h2>
      <br/>
      <Message msgType="Error" info={props.enableDisableStatusMsg?.info} />
      <p className={classes.Label}>UUID : {props.uuid} </p>
      <p className={classes.Label}>Username : {props.username} </p>
      <br />
      <div>{enableDisableForm}</div>
      <br />
      <Button id="enableMember" btnType="Search" clicked={enableMember} disabled={!valid}>
        Enable
      </Button>
      {props.loading?<Spinner/>:null}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    enableDisableStatusMsg: state.member.enableDisableStatusMsg,
    loading: state.member.accountStatusProcessing
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    enableMember: (userData, flag) =>
      dispatch(actions.enableDisableAccount(userData, flag)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnableMemberModal);
